module.exports = __webpack_public_path__ + "img/mobileaboutBanner.a6487e91.png";